import React from 'react';
function NewsListItem(props) {
    const {name,category,description,deleteItem} = props
    let elementClassName;
    switch (category){
        case "Education":
            elementClassName="bg-danger bg-gradient"
            break
        case "Nature":
            elementClassName="bg-primary bg-gradient"
            break
        case "Scientific":
            elementClassName="bg-secondary bg-gradient"
            break
        case "Sport":
            elementClassName="bg-info bg-gradient"
        break
        default:
            elementClassName="bg-info bg-gradient"
    }

    return (
        <div>
            <li className={`card flex-row shadow-lg text-white my-2 ${elementClassName}`}>
                <div className="card-body">
                    <h3 className="card-title">{name}</h3>
                    <p className="card-text">{description}</p>
                </div>
                <img src="https://images.unsplash.com/photo-1585829365295-ab7cd400c167?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8bmV3c3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60" alt="News Img" className="img-fluid w-25 d-inline"
                style={{"objectFit":"cover"}}
                />
                <span className='position-absolute top-0 end-90 translate-middle badge border  rounded-pill bg-light'>
                <button type="button" className="btn-close" aria-label="Close" onClick={deleteItem}> </button>
            </span>
            </li>
        </div>
    );
}

export default NewsListItem;